<p class="main-question">
  <strong>Elige tu tipo de cuenta</strong>
</p>
<p class="subtext mb-3">
  Elige la cuenta que va más contigo y tus operaciones.
</p>

<!-- Verificando servicio -->
<div *ngIf="checkingService" class="service-check">
  <mat-icon class="spinning">autorenew</mat-icon>
  <p class="subtext">Verificando disponibilidad del servicio...</p>
</div>

<!-- Servicio caído -->
<div *ngIf="!checkingService && otpServiceDown" class="service-down-banner">
  <mat-icon class="service-down-icon">error_outline</mat-icon>
  <p class="service-down-title">Falla técnica</p>
  <p class="service-down-msg">
    Nuestro servicio de verificación no está disponible en este momento.
    Por favor, intenta nuevamente más tarde.
  </p>
</div>

<div class="cards-wrapper" [class.disabled-cards]="checkingService || otpServiceDown">
  <div class="account-type-card" (click)="selectAccountType('personal')">
    <div class="icon-wrapper">
      <img
        class="card-icon"
        src="assets/img/users.png"
        alt="Cuenta personal"
      />
    </div>
    <div class="card-content">
      <h3 class="card-title">Personal</h3>
      <p class="card-description">
        Para enviar dinero a tus amigos y familia.
      </p>
    </div>
  </div>

  <div class="account-type-card" (click)="selectAccountType('empresas')">
    <div class="icon-wrapper">
      <img
        class="card-icon"
        src="assets/img/wallet.png"
        alt="Cuenta empresas"
      />
    </div>
    <div class="card-content">
      <h3 class="card-title">Empresas</h3>
      <p class="card-description">
        Gestiona los envíos para tus clientes.
      </p>
    </div>
  </div>
</div>
